module.exports = __webpack_public_path__ + "img/skypets-2.83ec5691.jpg";